
export default function ZipNeed() {
  return (
    <>
      <section className="zip-need-area">
        <img src="/assets/home/zip-need-vec.webp" alt="zipneed" className="img-responsive zip-need-vec" loading="lazy"/>
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-5 col-md-6">
              <img src="/assets/home/zip-need.webp" alt="zipcar" className=" img-responsive zip-need-img" />
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="zip-need-head">
                <h2 className="heading">Zipcar Clone App Is a  <span className="gradiant-color">Game-Changer </span> for Your Business</h2>
                <p>Looking to launch your own car-sharing service? Our Zipcar Clone App is a fully customizable, white-label solution that lets you build a seamless, tech-driven car rental platform—empowering users to rent vehicles on-demand, anytime, anywhere.</p>
                <p>The global car-sharing market is booming. Our Zipcar Clone App equips you with the tools to stay ahead—reducing idle fleet time, maximizing utilization, and offering eco-friendly mobility options that today’s users love.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
